import userRoutes from "./userRoutes";
import companyAdminRoutes from "./companyAdminRoutes";
import portPoliceRoutes from "./PortpoliceRoutes";
import superAdminRoutes from "./superAdmin";
import terminalPortPoliceRoutes from "./terminalPortPoliceRoutes";
import eoaRoutes from "./eoa";
import eouRoutes from "./eou";
import ppcAdminRoutes from "./ppcAdminRoutes";
let allRoutes = { portPoliceRoutes, companyAdminRoutes, userRoutes, superAdminRoutes, terminalPortPoliceRoutes, eoaRoutes, eouRoutes, ppcAdminRoutes};
export default allRoutes;
